// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:18:07

export default {
  "id": "thief-puzzle",
  "slug": "thief-puzzle",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/50d7b4a1adf4412fb913fc6cbcc228ab-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/50d7b4a1adf4412fb913fc6cbcc228ab/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Thief Puzzle",
      "description": "Master stealth and strategy in Thief Puzzle - become the ultimate stealth master in this captivating 2D puzzle game! In Thief Puzzle, you dive into a world of mischief and tactical gameplay. Take control of a thief’s hand, guiding it through intricate levels to snatch the prized possessions. With every successful heist, the challenges grow, testing your skills to think outside the box and act like a true master thief. So grab your mask and start your cunning journey in Thief Puzzle today!",
      "instructions": "Click and hold down Left mouse button to drag and guide the thiefs hand ",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "1player",
        "2d",
        "drag",
        "skill",
        "thief"
      ]
    },
    "zh-CN": {
      "title": "盗贼谜题",
      "description": "精通潜行与策略，在《盗贼解谜》中成为终极潜行大师！在这款迷人的2D解谜游戏中，你将深入一个充满恶作剧和战术游戏的世界。掌控盗贼之手，引导它穿过错综复杂的关卡，夺取珍宝。每一次成功的抢劫，挑战都会增加，考验你跳出思维定势、行动如真正的盗贼大师的能力。所以，戴上你的面具，今天就开始你的狡猾旅程吧！",
      "instructions": "点击并按住鼠标左键以拖动并引导盗贼的手",
      "genres": [
        "拼图"
      ],
      "tags": [
        "1名玩家",
        "2D",
        "拖拽",
        "技能",
        "盗贼"
      ]
    },
    "zh-TW": {
      "title": "盜賊謎題",
      "description": "掌握潛入與策略在盜賊拼圖遊戲中 - 成為這款引人入勝的2D拼圖遊戲中的絕世潛入大師！在盜賊拼图中，你將沉浸在一個惡作劇與策略遊戲的世界。操縱盜賊的手，引導它穿過複雜的關卡去搶奪珍貴的財物。每完成一次成功的搶奪，挑戰會變得更加挑戰，考驗你思考超脫框架的能力，並行為如同真正的盜賊大師。所以，抓起你的面具，今日起開啟你在盜賊拼圖中的狡猾旅程！",
      "instructions": "點擊並按住左鍵，拖動並引導盜賊的手",
      "genres": [
        "謎題"
      ],
      "tags": [
        "1玩家",
        "2D",
        "拖拽",
        "技能",
        "盜賊"
      ]
    },
    "zh-HK": {
      "title": "盜賊謎題",
      "description": "精通潛入及策略在盜賊謎題遊戲中 —— 成為這個吸引人的2D謎題遊戲中的最終潛入大師！在盜賊謎題中，你將墮入一個充滿淘氣和戰術遊戲的世界。操控盜賊的手，引導它穿過複雜的關卡以搶奪寶貴的財物。隨著每一次成功的盜劫，挑戰不斷升級，考驗你的思考能力，就像一位真正的盜賊大師一樣。所以，拿起你的面罩，開啟你在盜賊謎題中的狡猾旅程吧！",
      "instructions": "按住左鍵並拖動以引導盜賊的手",
      "genres": [
        "謎題"
      ],
      "tags": [
        "1玩家",
        "2D",
        "拖動",
        "技能",
        "盜賊"
      ]
    },
    "ja": {
      "title": "泥棒パズル",
      "description": "スティルスと戦略をマスターして、Thief Puzzleで最上のスティルスマスターに！Thief Puzzleでは、いたずらと戦術的なゲームプレイの世界に飛び込みます。盗賊の手を操り、複雑なレベルを通じて宝物を奪い取ります。成功した強盗ごとに、挑戦が増え、箱外を考えるスキルや本物のマスター盗賊としての行動を試されます。マスクを手に、Thief Puzzleでの狡猾な旅を今日から始めましょう！",
      "instructions": "左クリックボタンを押しながらドラッグして盗賊の手を導いてください。",
      "genres": [
        "パズル"
      ],
      "tags": [
        "1プレイヤー",
        "2D",
        "ドラッグ",
        "スキル",
        "泥棒"
      ]
    },
    "ko": {
      "title": "도둑 퍼즐",
      "description": "스티브 퍼즐에서 스플릿 라이팅과 전략을 익혀 이 captivatіng 2D 퍼즐 게임에서 최고의 스플릿 라이팅 마스터가 되세요! Thief Puzzle에서는, 이야기와 전략적인 게임 플레이의 세계로 뛰어들어, 도둑의 손을 이끌어 복잡한 레벨을 통과하여 귀중한 물건을 털어보세요. 성공적인 털이마다 도전이 증가하며, 그릇된 생각을 벗어나 진정한 마스터 도둑처럼 행동하는 능력을 테스트합니다. 이제 마스크를 씌워 Thief Puzzle에서 지혜로운 여정을 시작하세요!",
      "instructions": "좌클릭 후 고정하여 도둑의 손을 끌어당겨 이끌어주세요.",
      "genres": [
        "퍼즐"
      ],
      "tags": [
        "1플레이어",
        "2D",
        "드래그",
        "스킬",
        "도적"
      ]
    },
    "fr": {
      "title": "Voleur Puzzle",
      "description": "Maîtrisez le stealth et la stratégie dans Thief Puzzle - devenez le maître ultime du stealth dans ce captivant jeu de puzzle 2D ! Dans Thief Puzzle, vous plongez dans un monde de désordres et de jeu tactique. Prenez le contrôle de la main d'un voleur, guidez-la à travers des niveaux intricats pour dérober les possessions précieuses. À chaque vol réussi, les défis s'intensifient, mettant à l'épreuve vos capacités à penser hors de la boîte et à agir comme un véritable maître voleur. Alors, prenez votre masque et commencez votre voyage rusé dans Thief Puzzle aujourd'hui !",
      "instructions": "Cliquez et maintenez appuyé sur le bouton gauche de la souris pour glisser et guider la main du voleur",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "1 joueur",
        "2D",
        "glisser",
        "compétence",
        "voleur"
      ]
    }
  }
};
